export default "/assets/images/mila-opened-door-filter-boxes.7692ea7005ff4bc7.webp";